import React from 'react'
import { Step, StepAnswer } from '../components'
import { useOnboarding } from '../context'
import type { QuestionValues } from '../typings'
import type { StepProps } from './StepProps'

const AGES: QuestionValues = {
  key: 'is_minor',
  trackingKey: 'age',
  question: 'Confirm your age',
  choices: [
    { text: 'I am under 18', value: true },
    { text: 'I am 18+', value: false }
  ]
}

export const StudentStep = (props: StepProps) => {
  const { updateState } = useOnboarding()

  function resetTermsAndPermissions() {
    updateState({ acceptedTerms: false, hasAdultPermission: false })
  }

  return (
    <Step
      index={props.index}
      surveyKey={AGES.key}
      trackingKey={AGES.trackingKey}
      title={AGES.question}
    >
      {AGES.choices.map(({ text, value }) => {
        return (
          <StepAnswer
            key={`${text}-${value}`}
            question={AGES.question}
            surveyKey={AGES.key}
            text={text}
            value={value}
            onClick={() => {
              resetTermsAndPermissions()
            }}
          />
        )
      })}
    </Step>
  )
}
